/* eslint-disable */

import moment from "moment";

const ACCOUNT_PARENT_TYPE_GROUP = ["0", "1", "2", "3", "20"];
const ACCOUNT_CHILD_TYPE_GROUP = ["10"];

// 計測不能：4
// 95 % 以上： 厳しい 3
// 90 % 以上： やや厳しい 2
// 80 % 以上： 安定 1
// 80 % 未満： 良好 0

const FORECAST_ICONS = {
  "0": "icon.el.level0.png",
  "1": "icon.el.level1.png",
  "2": "icon.el.level2.png",
  "3": "icon.el.level3.png",
  "4": "icon.weather999.png"
};

const FORECAST_STRINGS = {
  "0": "良好",
  "1": "安定",
  "2": "やや厳しい",
  "3": "厳しい",
  "4": "計測不可"
};

const FORECAST_LEVELS = {
  "0": "level1",
  "1": "level1",
  "2": "level2",
  "3": "level3",
  "4": ""
};

const DEMAND_LEVELS = {
  "0": "level1",
  "1": "level1",
  "2": "level2",
  "3": "level3"
};

const BATTERY_ICONS = {
  "0": "icon.battery0.png",
  "1": "icon.battery1.png",
  "2": "icon.battery2.png",
  "3": "icon.battery3.png",
  "4": "icon.battery4.png",
  "5": "icon.battery5.png",
  "999": "icon999.png"
};

const DENPA_ICONS = {
  "0": "icon.radio0.png",
  "1": "icon.radio1.png",
  "2": "icon.radio2.png",
  "3": "icon.radio3.png",
  "4": "icon.radio4.png",
  "5": "icon.radio5.png",
  "999": "icon999.png"
};

const NOTICE_LEVEL = {
  "1": "通知",
  "2": "注意",
  "3": "警報"
};

const WEATHER_DIC = {
  "100": {
    title: "晴れ",
    icon: "icon.weather100.png"
  },
  "123": {
    title: "晴れ山沿い雷雨",
    icon: "icon.weather999.png"
  },
  "124": {
    title: "晴れ山沿い雪",
    icon: "icon.weather999.png"
  },
  "130": {
    title: "朝の内霧のち晴れ",
    icon: "icon.weather999.png"
  },
  "131": {
    title: "晴れ朝方霧",
    icon: "icon.weather999.png"
  },
  "500": {
    title: "快晴",
    icon: "icon.weather100.png"
  },
  "600": {
    title: "薄曇り",
    icon: "icon.weather600.png"
  },
  "101": {
    title: "晴れ時々くもり",
    icon: "icon.weather101.png"
  },
  "132": {
    title: "晴れ朝夕くもり",
    icon: "icon.weather999.png"
  },
  "102": {
    title: "晴れ一時雨",
    icon: "icon.weather102.png"
  },
  "103": {
    title: "晴れ時々雨",
    icon: "icon.weather100.png"
  },
  "106": {
    title: "晴れ一時雨か雪",
    icon: "icon.weather100.png"
  },
  "107": {
    title: "晴れ時々雨か雪",
    icon: "icon.weather100.png"
  },
  "120": {
    title: "晴れ朝夕一時雨",
    icon: "icon.weather999.png"
  },
  "121": {
    title: "晴れ朝の内一時雨",
    icon: "icon.weather999.png"
  },
  "140": {
    title: "晴れ時々雨で雷を伴う",
    icon: "icon.weather999.png"
  },
  "108": {
    title: "晴れ一時雨か雷雨",
    icon: "icon.weather999.png"
  },
  "104": {
    title: "晴れ一時雪",
    icon: "icon.weather104.png"
  },
  "105": {
    title: "晴れ時々雪",
    icon: "icon.weather100.png"
  },
  "160": {
    title: "晴れ一時雪か雨",
    icon: "icon.weather100.png"
  },
  "170": {
    title: "晴れ時々雪か雨",
    icon: "icon.weather100.png"
  },
  "110": {
    title: "晴れのち時々くもり",
    icon: "icon.weather999.png"
  },
  "111": {
    title: "晴れのちくもり",
    icon: "icon.weather999.png"
  },
  "112": {
    title: "晴れのち一時雨",
    icon: "icon.weather999.png"
  },
  "113": {
    title: "晴れのち時々雨",
    icon: "icon.weather999.png"
  },
  "114": {
    title: "晴れのち雨",
    icon: "icon.weather999.png"
  },
  "118": {
    title: "晴れのち雨か雪",
    icon: "icon.weather999.png"
  },
  "122": {
    title: "晴れ夕方一時雨",
    icon: "icon.weather999.png"
  },
  "126": {
    title: "晴れ昼頃から雨",
    icon: "icon.weather999.png"
  },
  "127": {
    title: "晴れ夕方から雨",
    icon: "icon.weather999.png"
  },
  "128": {
    title: "晴れ夜は雨",
    icon: "icon.weather999.png"
  },
  "129": {
    title: "晴れ夜半から雨",
    icon: "icon.weather999.png"
  },
  "119": {
    title: "晴れのち雨か雷雨",
    icon: "icon.weather999.png"
  },
  "125": {
    title: "晴れ午後は雷雨",
    icon: "icon.weather999.png"
  },
  "115": {
    title: "晴れのち一時雪",
    icon: "icon.weather999.png"
  },
  "116": {
    title: "晴れのち時々雪",
    icon: "icon.weather999.png"
  },
  "117": {
    title: "晴れのち雪",
    icon: "icon.weather999.png"
  },
  "181": {
    title: "晴れのち雪か雨",
    icon: "icon.weather999.png"
  },
  "200": {
    title: "くもり",
    icon: "icon.weather200.png"
  },
  "209": {
    title: "霧",
    icon: "icon.weather999.png"
  },
  "231": {
    title: "くもり海上海岸は霧か霧雨",
    icon: "icon.weather999.png"
  },
  "201": {
    title: "くもり時々晴れ",
    icon: "icon.weather201.png"
  },
  "223": {
    title: "くもり日中時々晴れ",
    icon: "icon.weather999.png"
  },
  "202": {
    title: "くもり一時雨",
    icon: "icon.weather202.png"
  },
  "203": {
    title: "くもり時々雨",
    icon: "icon.weather200.png"
  },
  "206": {
    title: "くもり一時雨か雪",
    icon: "icon.weather200.png"
  },
  "207": {
    title: "くもり時々雨か雪",
    icon: "icon.weather200.png"
  },
  "220": {
    title: "くもり朝夕一時雨",
    icon: "icon.weather999.png"
  },
  "221": {
    title: "くもり朝の内一時雨",
    icon: "icon.weather999.png"
  },
  "240": {
    title: "くもり時々雨で雷を伴う",
    icon: "icon.weather999.png"
  },
  "208": {
    title: "くもり一時雨か雷雨",
    icon: "icon.weather999.png"
  },
  "204": {
    title: "くもり一時雪",
    icon: "icon.weather204.png"
  },
  "205": {
    title: "くもり時々雪",
    icon: "icon.weather200.png"
  },
  "250": {
    title: "くもり時々雪で雷を伴う",
    icon: "icon.weather999.png"
  },
  "260": {
    title: "くもり一時雪か雨",
    icon: "icon.weather200.png"
  },
  "270": {
    title: "くもり時々雪か雨",
    icon: "icon.weather200.png"
  },
  "572": {
    title: "曇り時々猛暑",
    icon: "icon.weather999.png"
  },
  "210": {
    title: "くもりのち時々晴れ",
    icon: "icon.weather999.png"
  },
  "211": {
    title: "くもりのち晴れ",
    icon: "icon.weather999.png"
  },
  "212": {
    title: "くもりのち一時雨",
    icon: "icon.weather999.png"
  },
  "213": {
    title: "くもりのち時々雨",
    icon: "icon.weather999.png"
  },
  "214": {
    title: "くもりのち雨",
    icon: "icon.weather999.png"
  },
  "218": {
    title: "くもりのち雨か雪",
    icon: "icon.weather999.png"
  },
  "222": {
    title: "くもり夕方一時雨",
    icon: "icon.weather999.png"
  },
  "224": {
    title: "くもり昼頃から雨",
    icon: "icon.weather999.png"
  },
  "225": {
    title: "くもり夕方から雨",
    icon: "icon.weather999.png"
  },
  "226": {
    title: "くもり夜は雨",
    icon: "icon.weather999.png"
  },
  "227": {
    title: "くもり夜半から雨",
    icon: "icon.weather999.png"
  },
  "219": {
    title: "くもりのち雨か雷雨",
    icon: "icon.weather999.png"
  },
  "215": {
    title: "くもりのち一時雪",
    icon: "icon.weather999.png"
  },
  "216": {
    title: "くもりのち時々雪",
    icon: "icon.weather999.png"
  },
  "217": {
    title: "くもりのち雪",
    icon: "icon.weather999.png"
  },
  "228": {
    title: "くもり昼頃から雪",
    icon: "icon.weather999.png"
  },
  "229": {
    title: "くもり夕方から雪",
    icon: "icon.weather999.png"
  },
  "230": {
    title: "くもり夜は雪",
    icon: "icon.weather999.png"
  },
  "281": {
    title: "くもりのち雪か雨",
    icon: "icon.weather999.png"
  },
  "582": {
    title: "曇りのち猛暑",
    icon: "icon.weather999.png"
  },
  "300": {
    title: "雨",
    icon: "icon.weather300.png"
  },
  "304": {
    title: "雨か雪",
    icon: "icon.weather304.png"
  },
  "306": {
    title: "大雨",
    icon: "icon.weather999.png"
  },
  "328": {
    title: "雨一時強く降る",
    icon: "icon.weather999.png"
  },
  "329": {
    title: "雨一時みぞれ",
    icon: "icon.weather999.png"
  },
  "350": {
    title: "雨で雷を伴う",
    icon: "icon.weather999.png"
  },
  "308": {
    title: "雨で暴風を伴う",
    icon: "icon.weather999.png"
  },
  "301": {
    title: "雨時々晴れ",
    icon: "icon.weather301.png"
  },
  "302": {
    title: "雨時々止む",
    icon: "icon.weather302.png"
  },
  "303": {
    title: "雨時々雪",
    icon: "icon.weather300.png"
  },
  "309": {
    title: "雨一時雪",
    icon: "icon.weather999.png"
  },
  "322": {
    title: "雨朝晩一時雪",
    icon: "icon.weather999.png"
  },
  "573": {
    title: "雨時々猛暑",
    icon: "icon.weather999.png"
  },
  "311": {
    title: "雨のち晴れ",
    icon: "icon.weather999.png"
  },
  "316": {
    title: "雨か雪のち晴れ",
    icon: "icon.weather999.png"
  },
  "320": {
    title: "朝の内雨のち晴れ",
    icon: "icon.weather999.png"
  },
  "323": {
    title: "雨昼頃から晴れ",
    icon: "icon.weather999.png"
  },
  "324": {
    title: "雨夕方から晴れ",
    icon: "icon.weather999.png"
  },
  "325": {
    title: "雨夜は晴れ",
    icon: "icon.weather999.png"
  },
  "313": {
    title: "雨のちくもり",
    icon: "icon.weather999.png"
  },
  "317": {
    title: "雨か雪のちくもり",
    icon: "icon.weather999.png"
  },
  "321": {
    title: "朝の内雨のちくもり",
    icon: "icon.weather999.png"
  },
  "314": {
    title: "雨のち時々雪",
    icon: "icon.weather999.png"
  },
  "315": {
    title: "雨のち雪",
    icon: "icon.weather999.png"
  },
  "326": {
    title: "雨夕方から雪",
    icon: "icon.weather999.png"
  },
  "327": {
    title: "雨夜は雪",
    icon: "icon.weather999.png"
  },
  "583": {
    title: "雨のち猛暑",
    icon: "icon.weather999.png"
  },
  "400": {
    title: "雪",
    icon: "icon.weather400.png"
  },
  "405": {
    title: "大雪",
    icon: "icon.weather999.png"
  },
  "425": {
    title: "雪一時強く降る",
    icon: "icon.weather999.png"
  },
  "426": {
    title: "雪のちみぞれ",
    icon: "icon.weather999.png"
  },
  "427": {
    title: "雪一時みぞれ",
    icon: "icon.weather999.png"
  },
  "450": {
    title: "雪で雷を伴う",
    icon: "icon.weather999.png"
  },
  "340": {
    title: "雪か雨",
    icon: "icon.weather999.png"
  },
  "406": {
    title: "風雪強い",
    icon: "icon.weather999.png"
  },
  "407": {
    title: "暴風雪",
    icon: "icon.weather999.png"
  },
  "401": {
    title: "雪時々晴れ",
    icon: "icon.weather401.png"
  },
  "402": {
    title: "雪時々止む",
    icon: "icon.weather402.png"
  },
  "403": {
    title: "雪時々雨",
    icon: "icon.weather403.png"
  },
  "409": {
    title: "雪一時雨",
    icon: "icon.weather999.png"
  },
  "411": {
    title: "雪のち晴れ",
    icon: "icon.weather999.png"
  },
  "420": {
    title: "朝の内雪のち晴れ",
    icon: "icon.weather999.png"
  },
  "361": {
    title: "雪か雨のち晴れ",
    icon: "icon.weather999.png"
  },
  "413": {
    title: "雪のちくもり",
    icon: "icon.weather999.png"
  },
  "421": {
    title: "朝の内雪のちくもり",
    icon: "icon.weather999.png"
  },
  "371": {
    title: "雪か雨のちくもり",
    icon: "icon.weather999.png"
  },
  "414": {
    title: "雪のち雨",
    icon: "icon.weather999.png"
  },
  "422": {
    title: "雪昼頃から雨",
    icon: "icon.weather999.png"
  },
  "423": {
    title: "雪夕方から雨",
    icon: "icon.weather999.png"
  },
  "424": {
    title: "雪夜半から雨",
    icon: "icon.weather999.png"
  },
  "430": {
    title: "みぞれ",
    icon: "icon.weather430.png"
  },
  "550": {
    title: "猛暑",
    icon: "icon.weather999.png"
  },
  "552": {
    title: "猛暑時々曇り",
    icon: "icon.weather999.png"
  },
  "553": {
    title: "猛暑時々雨",
    icon: "icon.weather999.png"
  },
  "558": {
    title: "猛暑時々大雨・嵐",
    icon: "icon.weather999.png"
  },
  "562": {
    title: "猛暑のち曇り",
    icon: "icon.weather999.png"
  },
  "563": {
    title: "猛暑のち雨",
    icon: "icon.weather999.png"
  },
  "568": {
    title: "猛暑のち大雨・嵐",
    icon: "icon.weather999.png"
  },
  "851": {
    title: "大雨・嵐時々晴れ",
    icon: "icon.weather999.png"
  },
  "852": {
    title: "大雨・嵐時々曇り",
    icon: "icon.weather999.png"
  },
  "853": {
    title: "大雨・嵐時々雨",
    icon: "icon.weather999.png"
  },
  "854": {
    title: "大雨・嵐時々雪",
    icon: "icon.weather999.png"
  },
  "855": {
    title: "大雨・嵐時々猛暑",
    icon: "icon.weather999.png"
  },
  "861": {
    title: "大雨・嵐のち晴れ",
    icon: "icon.weather999.png"
  },
  "862": {
    title: "大雨・嵐のち曇り",
    icon: "icon.weather999.png"
  },
  "863": {
    title: "大雨・嵐のち雨",
    icon: "icon.weather999.png"
  },
  "864": {
    title: "大雨・嵐のち雪",
    icon: "icon.weather999.png"
  },
  "865": {
    title: "大雨・嵐のち猛暑",
    icon: "icon.weather999.png"
  },
  "871": {
    title: "晴れ時々大雨・嵐",
    icon: "icon.weather999.png"
  },
  "872": {
    title: "曇り時々大雨・嵐",
    icon: "icon.weather999.png"
  },
  "873": {
    title: "雨時々大雨・嵐",
    icon: "icon.weather999.png"
  },
  "874": {
    title: "雪時々大雨・嵐",
    icon: "icon.weather999.png"
  },
  "881": {
    title: "晴れのち大雨・嵐",
    icon: "icon.weather999.png"
  },
  "882": {
    title: "曇りのち大雨・嵐",
    icon: "icon.weather999.png"
  },
  "883": {
    title: "雨のち大雨・嵐",
    icon: "icon.weather999.png"
  },
  "884": {
    title: "雪のち大雨・嵐",
    icon: "icon.weather999.png"
  },
  "999": {
    title: "欠測",
    icon: "icon.weather999.png"
  }
};
const TEMP_THRESHOLD = 28;

const DEMAND_STATUS = {
  "0": {
    msg: "良 好",
    front: "demand-status-front-level-1",
    back: "demand-status-back-level-1"
  },
  "1": {
    msg: "注 意",
    front: "demand-status-front-level-2",
    back: "demand-status-back-level-2"
  },
  "2": {
    msg: "警 報",
    front: "demand-status-front-level-3",
    back: "demand-status-back-level-3"
  },
  "999": {
    msg: "",
    front: "",
    back: ""
  }
};

const CONTROL_STATUS = {
  "0": {
    msg: "未制御",
    front: "demand-status-front-level-1",
    back: "demand-status-back-level-1"
  },
  "2": {
    msg: "注 意",
    front: "demand-status-front-level-2",
    back: "demand-status-back-level-2"
  },
  "1": {
    msg: "限 界",
    front: "demand-status-front-level-3",
    back: "demand-status-back-level-3"
  },
  "999": {
    msg: "",
    front: "",
    back: ""
  }
};

const SETTING_STATUS = {
  "true": {
    msg: "有",
    color: "setting-on"
  },
  "false": {
    msg: "無",
    color: "setting-off"
  }
};

const ACCOUNT_TYPE = {
  "20": "グループ",
  "10": "シングル",
  "999": ""
};

const FUNCTION_TYPE = {
  "1": "電力見える化",
  "2": "ES",
  "999": ""
};

const SYSTEM_DIAGRAM_DIVISION_DIVISION =
{
  "" : "未選択",
  "binary_icon": "2値アイコン",
  "icon": "アイコン",
  "numerical": "数値",
  "text": "テキスト",
  "date": "取込時刻",
};  
const DIAGRAM_FONT_SIZE = 
[
    6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 30, 35, 40, 45
];
const DIAGRAM_FONT_COLOR =
{
  1 : {
    name: "黒",
    name_en: "black"
  },
  2 : {
    name: "赤",
    name_en: "red"
  },
  3 : {
    name: "青",
    name_en: "blue"
  },
  4 : {
    name: "黄",
    name_en: "yellow"
  },
  5 : {
    name: "緑",
    name_en: "green"
  },
  6 : {
    name: "紫",
    name_en: "purple"
  },
  7 : {
    name: "オレンジ",
    name_en: "orange"
  },
  8 : {
    name: "白",
    name_en: "white"
  },
};
const DIAGRAM_FONT_STYLE = 
{
  0 : {
    name: "標準",
    name_en: "normal"
  },
  1 : {
    name: "太字",
    name_en: "bold"
  },
  2 : {
    name: "斜体",
    name_en: "italic"
  },
  3 : {
    name: "太字斜体",
    name_en: "bold italic"
  }
};
const DIAGRAM_LAYER = [1,2,3];
const SYSTEM_DIAGRAM_INFO_DIVISION =
[
  '空調',
  '受変電',
  '発電'
];
export default {
  methods: {
    getNoticeLabel: function(value) {
      const text = NOTICE_LEVEL[value];
      return text != undefined ? text : "";
    },
    isParentGroupe: function(loginType) {
      return ACCOUNT_PARENT_TYPE_GROUP.indexOf(loginType) >= 0;
    },
    isChildGroupe: function(loginType) {
      return ACCOUNT_CHILD_TYPE_GROUP.indexOf(loginType) >= 0;
    },
    getForecastIconUrl: function(code) {
      let icon = FORECAST_ICONS[String(code)];
      if (icon == undefined) {
        icon = FORECAST_ICONS["4"];
      }
      return `/assets/images/common/${icon}`;
    },
    getForecastString: function(code) {
      let str = FORECAST_STRINGS[String(code)];
      if (str == undefined) {
        str = code;
      }
      return str;
    },
    getForecastLevel: function (code) {
      let str = FORECAST_LEVELS[String(code)];
      if (str == undefined) {
        str = "";
      }
      return str;
    },
    getIncreaseRateLevel: function (value) {
      if (value == undefined) {
        return "";
      }

      const num = Number(value);
      if (isNaN(num)) {
        return "";
      }

      if (num >= 5) {
        return "level3";
      } else if (num >= 3) {
        return "level2";
      }
      return "level1";
    },
    getDemandLevel: function (value, thresholds) {
      if (value == '-') {
        return "";
      }

      const level = this.calcAlertLevel(value, thresholds);
      let str = DEMAND_LEVELS[String(level)];
      if (str == undefined) {
        str = "";
      }
      return str;
    },
    getWeatherIconUrl: function(code) {
      let weather = WEATHER_DIC["999"];
      if (code == undefined) {
        return `/assets/images/common/${weather.icon}`;
      }
      weather = WEATHER_DIC[String(code)];
      if (weather == undefined) {
        weather = WEATHER_DIC["999"];
      }
      return `/assets/images/common/${weather.icon}`;
    },
    getWeatherString: function(code) {
      let weather = WEATHER_DIC["999"];
      if (code == undefined) {
        return weather.title;
      }
      weather = WEATHER_DIC[String(code)];
      if (weather == undefined) {
        weather = WEATHER_DIC["999"];
      }
      return weather.title;
    },
    getTempStyle: function(temp) {
      if (temp == undefined) {
        return "low";
      }
      return parseFloat(temp) >= TEMP_THRESHOLD ? "high" : "low";
    },
    getBatteryIconUrl: function(code) {
      let icon = BATTERY_ICONS[String(code)];
      if (icon == undefined) {
        icon = BATTERY_ICONS["999"];
      }
      return `/assets/images/activity/${icon}`;
    },
    getDenpaIconUrl: function(code) {
      let icon = DENPA_ICONS[String(code)];
      if (icon == undefined) {
        icon = DENPA_ICONS["999"];
      }
      return `/assets/images/activity/${icon}`;
    },
    getFormatForecastDate: function(date) {
      // date = date + " 00:00:00"
      // const dateObj = new Date(date)
      if (moment(date).isValid()) {
        return moment(date).format("MM月DD日");
      } else {
        return "";
      }
    },
    isEquipment: function(using) {
      let icon = "";
      if (using) {
        icon = "/assets/images/activity/icon.true.png";
      }
      return icon;
    },
    isFunction: function(count) {
      let icon = "";
      if (count > 0) {
        icon = "/assets/images/activity/icon.true.png";
      }
      return icon;
    },
    getDeviceAirConditionerIconUrl: function(using) {
      let icon = "icon999.png";
      if (using) {
        icon = "icon.aircon.png";
      }
      return `/assets/images/activity/${icon}`;
    },
    getDeviceReceiverIconUrl: function(using) {
      let icon = "icon999.png";
      if (using) {
        icon = "icon.receiver.png";
      }
      return `/assets/images/activity/${icon}`;
    },
    getDeviceGeneratorIconUrl: function(using) {
      let icon = "icon999.png";
      if (using) {
        icon = "icon.generator.png";
      }
      return `/assets/images/activity/${icon}`;
    },
    getDeviceElectricIconUrl: function(using) {
      let icon = "icon999.png";
      if (using) {
        icon = "icon.electric.png";
      }
      return `/assets/images/activity/${icon}`;
    },
    calcAlertLevel: function(value, threshold) {
      if (value == undefined) {
        return 4;
      }
      const p = parseFloat(value) / parseFloat(threshold);
      // 95 % 以上： 厳しい 3
      // 90 % 以上： やや厳しい 2
      // 80 % 以上： 安定 1
      // 80 % 未満： 良好 0

      if (p >= 0.95) {
        return 3;
      } else if (p >= 0.9) {
        return 2;
      } else if (p >= 0.8) {
        return 1;
      } else {
        return 0;
      }
    },
    getMonitoringDateOptions: function() {
      const today = moment();
      today.add(-14, "d");
      let options = [];
      for (let index = 0; index < 21; index++) {
        // 前２週間、後１週間
        options.push({
          value: today.add(1, "d").format("YYYY/MM/DD"),
          text: today.format("YYYY年MM月DD日")
        });
      }
      return options;
    },
    getMonitoringMonthOptions: function () {
      const today = moment();
      today.add(-36, "M");
      let options = [];
      for (let index = 0; index < 36; index++) {
        options.push({
          value: today.add(1, "M").format("YYYY/MM"),
          text: today.format("YYYY年MM月")
        });
      }
      return options;
    },
    getMonitoringYearOptions: function () {
      const today = moment();
      today.add(-5, "y");
      let options = [];
      for (let index = 0; index < 5; index++) {
        options.push({
          value: today.add(1, "y").format("YYYY"),
          text: today.format("YYYY年")
        });
      }
      return options;
    },
    getRealtimeDateOptions: function() {
      const today = moment();
      today.add(-14, "d");
      let options = [];
      for (let index = 0; index < 14; index++) {
        // 前２週間
        options.push({
          value: today.add(1, "d").format("YYYY/MM/DD"),
          text: today.format("YYYY年MM月DD日")
        });
      }
      return options;
    },
    createMonitoringTimeTable48ForDemand: function(dateStr) {
      dateStr = dateStr + "00:30:00";
      let start = moment.utc(dateStr, "YYYY/MM/DD HH:mm:ss");
      let table = [];
      for (let index = 0; index < 48; index++) {
        table.push(start.format("YYYY/MM/DD HH:mm:ss"));
        start.add(30, "minute");
      }
      return table;
    },
    createMonitoringTimeTable48: function(dateStr) {
      dateStr = dateStr + "00:00:00";
      let start = moment.utc(dateStr, "YYYY/MM/DD HH:mm:ss");
      let table = [];
      for (let index = 0; index < 48; index++) {
        table.push(start.format("YYYY/MM/DD HH:mm:ss"));
        start.add(30, "minute");
      }
      return table;
    },
    createMonitoringTimeTable24: function(dateStr) {
      dateStr = dateStr + "00:00:00";
      let start = moment.utc(dateStr, "YYYY/MM/DD HH:mm:ss");
      let table = [];
      for (let index = 0; index < 24; index++) {
        table.push(start.format("YYYY/MM/DD HH:mm:ss"));
        start.add(1, "hour");
      }
      return table;
    },
    createMonitoringTimeTable12: function(dateStr) {
      dateStr = dateStr + "00:00:00";
      let start = moment.utc(dateStr, "YYYY/MM/DD HH:mm:ss");
      let table = [];
      for (let index = 0; index < 24; index++) {
        table.push(start.format("YYYY/MM/DD HH:mm:ss"));
        start.add(2, "hour");
      }
      return table;
    },
    createRealtimeTimeTable: function(start, end, measureInstrument) {
      const startDate = moment.utc(start, "YYYY/MM/DD");
      const endDate = moment.utc(end, "YYYY/MM/DD").add(1, "days");
      const numOfDays = endDate.diff(startDate, "days");

      let table = [];
      let minute = 1;
      if (measureInstrument == 1) {
        minute = 5;
      }
      for (let index = 0; index < (numOfDays * 24 * 60) / minute; index++) {
        table.push(startDate.format("YYYY/MM/DD HH:mm:ss"));
        startDate.add(minute, "minute");
      }
      return table;
    },
    createRealtimeLabel: function(start, end, measureInstrument) {
      const startDate = moment.utc(start, "YYYY/MM/DD");
      const endDate = moment.utc(end, "YYYY/MM/DD").add(1, "days");
      const numOfDays = endDate.diff(startDate, "days");

      let table = [];
      let lastLabel = "";
      let minute = 1;
      if (measureInstrument == 1) {
        minute = 5;
      }
      for (let index = 0; index < (numOfDays * 24 * 60) / minute; index++) {
        const label = startDate.format("MM/DD");
        startDate.add(minute, "minute");
        if (lastLabel != label) {
          table.push(label);
          lastLabel = label;
          if (index > 1 && table[index - 1] != "") {
            table[index - 1] = "";
          }
        } else {
          const time = startDate.format("HH:mm");
          if (numOfDays == 1) {
            if (
              startDate.format("mm") == "00" &&
              parseInt(startDate.format("HH")) % 2 == 0
            ) {
              table.push(time);
            } else {
              table.push("");
            }
          } else if (numOfDays == 2) {
            if (
              startDate.format("mm") == "00" &&
              parseInt(startDate.format("HH")) % 3 == 0
              // startDate.format("HH") != "24" &&
              // startDate.format("HH") != "00"
            ) {
              table.push(time);
            } else {
              table.push("");
            }
          } else if (numOfDays == 3) {
            if (
              startDate.format("mm") == "00" &&
              parseInt(startDate.format("HH")) % 4 == 0
            ) {
              table.push(time);
            } else {
              table.push("");
            }
          } else if (numOfDays == 4) {
            if (
              startDate.format("mm") == "00" &&
              parseInt(startDate.format("HH")) % 6 == 0
            ) {
              table.push(time);
            } else {
              table.push("");
            }
          } else {
            if (
              startDate.format("mm") == "00" &&
              parseInt(startDate.format("HH")) % 12 == 0
            ) {
              table.push(time);
            } else {
              table.push("");
            }
          }
        }
      }
      return table;
    },
    addComma: function (value) {
      return value.toLocaleString();
    },
    numComma: function (value) {
    if ((value == null) || (isNaN(value))) {
        return "-";
      } else {
        return Number(value).toLocaleString();
      }
    },
    getDemandStatus: function(control, code) {
      let ret = "";
      if (control == true) {
        ret = CONTROL_STATUS[String(code)];
        if (ret == undefined) {
          ret = CONTROL_STATUS[String("999")];
        }
      } else {
        ret = DEMAND_STATUS[String(code)];
        if (ret == undefined) {
          ret = DEMAND_STATUS[String("999")];
        }
      }
      return ret;
    },
    getDemandStatusComp: function(power, demand) {
      let ret = DEMAND_STATUS[String("999")];
      if (power < demand) {
        ret = DEMAND_STATUS[String("2")];
      }
      return ret;
    },
    getSettingStatus: function(status) {
      let ret = SETTING_STATUS[String(status)];
      if (ret == undefined) {
        ret = SETTING_STATUS[String("false")];
      }
      return ret;
    },
    getAlertNotify: function(count) {
      let ret = "";
      if (count > 0) {
        ret = "alert-notify";
      }
      return ret;
    },
    getAccountType: function(accountType, functionType) {
      let ret = ACCOUNT_TYPE[String(accountType)];
      if (ret == undefined) {
        ret = ACCOUNT_TYPE["999"];
      } else {
        if (accountType != 20) {
          ret = FUNCTION_TYPE[String(functionType)];
          if (ret == undefined) {
            ret = FUNCTION_TYPE["999"];
          }
        }
      }
      return ret;
    }
  },
  isParentGroupe: function(loginType) {
    return ACCOUNT_PARENT_TYPE_GROUP.indexOf(loginType) >= 0;
  },
  isChildGroupe: function(loginType) {
    return ACCOUNT_CHILD_TYPE_GROUP.indexOf(loginType) >= 0;
  },
  getAccountType: function(accountType, functionType) {
    let ret = ACCOUNT_TYPE[String(accountType)];
    if (ret == undefined) {
      ret = ACCOUNT_TYPE["999"];
    } else {
      if (accountType != 20) {
        ret = FUNCTION_TYPE[String(functionType)];
        if (ret == undefined) {
          ret = FUNCTION_TYPE["999"];
        }
      }
    }
    return ret;
  },
addComma: function (value) {
    return value.toLocaleString();
  },
  numComma: function (value) {
    if ((value == null) || (isNaN(value))) {
      return "-";
    } else {
      return Number(value).toLocaleString();
    }
  },
  getDivisionNameJP: function(divisionName) {
    if(SYSTEM_DIAGRAM_DIVISION_DIVISION[divisionName])
      return SYSTEM_DIAGRAM_DIVISION_DIVISION[divisionName]
    return '未選択'
  },
  getSystemDiagramInfoDivisionList: function() {
    return SYSTEM_DIAGRAM_INFO_DIVISION;
  },
  getFontSizeList: function() {
    return DIAGRAM_FONT_SIZE
  },
  getFontColorList: function() {
    return Object.keys(DIAGRAM_FONT_COLOR).map((key) => ({'value': key, 'name': DIAGRAM_FONT_COLOR[key]}))
  },
  getFontColorName: function(fontColorValue) {
    const fontColor = DIAGRAM_FONT_COLOR[fontColorValue]
    if (fontColor) {
      return fontColor.name_en
    }
    return 'black'
  },
  getFontStyleList: function() {
    return Object.keys(DIAGRAM_FONT_STYLE).map((key) => ({'value': key, 'name': DIAGRAM_FONT_STYLE[key]}))
  },
  getFontStyleName: function(fontStyleValue) {
    const fontStyle = DIAGRAM_FONT_STYLE[fontStyleValue]
    if (fontStyle) {
      return fontStyle.name_en
    }
    return 'normal'
  },
  getLayerList: function() {
    return DIAGRAM_LAYER
  },
  exportData: function(resp, prefixFilename, header) {
    if (resp) {
        let data = resp; let filename = ''
        const dateTime = (new Date()).toISOString().split('T')[0]
        const fileType = '.csv'
        filename = prefixFilename + dateTime + fileType || 'export.csv'
        let encodingType = 'data:text/csv;charset=utf-8,%EF%BB%BF'
        let csvContent = ''
        // add header
        let row = Object.keys(header).map((k) => header[k]).join(',')
        csvContent = row.replace(/(?:\r\n|\r|\n)/g, ' ') + '\r\n'
        // content data
        for(let i =0; i < data.length; i++) {
          csvContent += data[i]
          if (i < data.length -1) {
            csvContent += '\r\n'
          }
        }
        
        let encodedUri = encodeURI(csvContent)
        let blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv; charset=utf-8' })

        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename)
        } else {
            URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.setAttribute('class', 'export-csv-file')
            link.setAttribute('href', encodingType + encodedUri)
            link.setAttribute('download', filename)
            link.setAttribute('style', 'visibility:hidden')
            document.body.appendChild(link) // Required for FF
            link.click() // This will download the data file named "CSVダウンロード_YYYY-MM-DD".
            window.URL.revokeObjectURL(data)
        }
    };
  }
};
